import {
  CloseButton,
  Popover,
  PopoverButton,
  PopoverPanel,
} from '@headlessui/react';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import ChevronDownIcon from '@/assets/chevron-down.svg';
import { Button } from '@/components/ui/button';
import { urls } from '@/constants/urls';
import { cx } from '@/utils/cx';

export type AccountDropdownProps = {
  onSignOutClick?: () => void;
};

export const AccountDropdown: FC<AccountDropdownProps> = ({
  onSignOutClick,
}) => (
  <Popover className="relative">
    <div className="h-5 w-5">
      <PopoverButton
        aria-label="account menu dropdown"
        className={cx(
          'focusable',
          'rounded-md text-gray-400 data-active:text-gray-500 data-hover:text-gray-500',
        )}
      >
        <ChevronDownIcon />
      </PopoverButton>
    </div>
    <PopoverPanel
      transition
      anchor={{ to: 'bottom', gap: 30, offset: -50 }}
      className="z-10 w-40 divide-y divide-gray-900/10 rounded-md bg-white text-sm/6 drop-shadow-xs transition duration-200 ease-in-out data-closed:-translate-y-1 data-closed:opacity-0"
    >
      <div className="p-3">
        <CloseButton
          as={Link}
          className={cx(
            'focusable',
            'block rounded-lg px-3 py-2 transition hover:bg-gray-400/10',
          )}
          to={urls.account}
        >
          <p className="font-semibold text-gray-500">My Account</p>
        </CloseButton>
      </div>
      {onSignOutClick && (
        <div className="p-3">
          <Button
            className="w-full"
            onClick={onSignOutClick}
            variant="primary-warning"
          >
            Sign Out
          </Button>
        </div>
      )}
    </PopoverPanel>
  </Popover>
);
